var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlayStore(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 147.358,
    height: 38.932,
    viewBox: "0 0 147.358 38.932",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1134",
    "data-name": "Path 1134",
    d: "M158.681,343.007l-7.533-4.35-14.531-8.39c-.807-.466-1.61-.184-1.61.79V365.24c0,.73.575,1.044,1.276.64l14.866-8.584,7.533-4.349,7.241-4.18c.85-.491.768-1.164.051-1.55S158.681,343.007,158.681,343.007Z",
    transform: "translate(-135.006 -330.047)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0067a2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.403,
    stopColor: "#3d91a8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.805,
    stopColor: "#74b7ae"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8ac6b1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#50b09b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e9e486"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#dc1b24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.228,
    stopColor: "#c1203b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.748,
    stopColor: "#8a2b6c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#753080"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#eb7165"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.003,
    stopColor: "#eb7164"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.675,
    stopColor: "#f9a85e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffbe5c"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1021",
    "data-name": "Group 1021",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "PLAY",
    transform: "translate(0 2.921)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1001",
    "data-name": "Group 1001",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1130",
    "data-name": "Path 1130",
    d: "M135.006,328.285V365.3l18.663-18.5Z",
    transform: "translate(-135.006 -328.861)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1131",
    "data-name": "Path 1131",
    d: "M158.681,341.543l-7.533-4.349-16.142-9.32v.135l18.663,18.505Z",
    transform: "translate(-135.006 -328.583)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1132",
    "data-name": "Path 1132",
    d: "M135.006,403.442v.135l16.142-9.32,7.533-4.349-5.012-4.97Z",
    transform: "translate(-135.006 -367.008)",
    fill: "url(#linear-gradient-3)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1133",
    "data-name": "Path 1133",
    d: "M197.152,369.721l-5.013,4.971,5.012,4.97,8.609-4.97Z",
    transform: "translate(-173.477 -356.761)",
    fill: "url(#linear-gradient-4)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1015",
    "data-name": "Group 1015",
    transform: "translate(112.485 12.607)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1135",
    "data-name": "Path 1135",
    d: "M484.376,384.088a4.653,4.653,0,0,1-1.92-.388A3.619,3.619,0,0,1,481,382.507h-.117a14.5,14.5,0,0,1,.117,1.787v4.429h-1.629V373.128h1.326l.225,1.473H481a3.787,3.787,0,0,1,1.464-1.277,4.446,4.446,0,0,1,1.914-.393,3.978,3.978,0,0,1,3.3,1.463,7.794,7.794,0,0,1-.019,8.225A3.988,3.988,0,0,1,484.376,384.088Zm-.236-9.771a2.889,2.889,0,0,0-2.386.913,4.705,4.705,0,0,0-.757,2.907v.363a5.385,5.385,0,0,0,.757,3.246,2.877,2.877,0,0,0,2.425.977,2.523,2.523,0,0,0,2.186-1.129,5.358,5.358,0,0,0,.79-3.114,5.157,5.157,0,0,0-.79-3.088A2.6,2.6,0,0,0,484.14,374.317Z",
    transform: "translate(-479.368 -368.611)",
    fill: "#ececec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1136",
    "data-name": "Path 1136",
    d: "M516.574,374.984h-1.63V359.7h1.63Z",
    transform: "translate(-503.323 -359.703)",
    fill: "#ececec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1137",
    "data-name": "Path 1137",
    d: "M533.322,383.932,533,382.4h-.078a4.517,4.517,0,0,1-1.606,1.37,4.877,4.877,0,0,1-2,.359,3.6,3.6,0,0,1-2.509-.825,3.008,3.008,0,0,1-.909-2.347q0-3.26,5.215-3.418l1.827-.059v-.667a2.726,2.726,0,0,0-.546-1.871,2.239,2.239,0,0,0-1.743-.6,7.1,7.1,0,0,0-3.044.825l-.5-1.247a7.658,7.658,0,0,1,1.744-.677,7.545,7.545,0,0,1,1.9-.246,4.1,4.1,0,0,1,2.853.854,3.569,3.569,0,0,1,.928,2.74v7.345Zm-3.683-1.148a3.312,3.312,0,0,0,2.391-.835,3.091,3.091,0,0,0,.869-2.338v-.972l-1.631.068a5.93,5.93,0,0,0-2.8.6,1.821,1.821,0,0,0-.859,1.664,1.677,1.677,0,0,0,.535,1.345A2.219,2.219,0,0,0,529.639,382.783Z",
    transform: "translate(-510.698 -368.651)",
    fill: "#ececec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1138",
    "data-name": "Path 1138",
    d: "M555.222,373.533h1.747l2.357,6.138a23.364,23.364,0,0,1,.963,3.035h.079q.128-.5.535-1.715t2.666-7.458h1.749l-4.626,12.256a6.114,6.114,0,0,1-1.606,2.578,3.415,3.415,0,0,1-2.253.76,6.583,6.583,0,0,1-1.474-.166v-1.306a5.691,5.691,0,0,0,1.208.118,2.49,2.49,0,0,0,2.4-1.886l.6-1.532Z",
    transform: "translate(-530.445 -369.015)",
    fill: "#ececec"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1016",
    "data-name": "Group 1016",
    transform: "translate(38.169 11.405)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1139",
    "data-name": "Path 1139",
    d: "M384.94,374.924a3.667,3.667,0,0,1-.293,6.236,1.583,1.583,0,0,0-.63,1.1,1.235,1.235,0,0,0,.586.968l.811.629c.99.833,1.89,1.6,1.89,3.153,0,2.116-2.049,4.254-5.92,4.254-3.265,0-4.84-1.553-4.84-3.22a3.239,3.239,0,0,1,1.734-2.746,9.7,9.7,0,0,1,4.3-1.036,2.356,2.356,0,0,1-.676-1.529,2.032,2.032,0,0,1,.225-.879c-.249.023-.5.045-.721.045a3.559,3.559,0,0,1-3.737-3.534,4.05,4.05,0,0,1,1.44-3.017,6.139,6.139,0,0,1,4.031-1.239h4.637l-1.441.811Zm-1.6,10a3.485,3.485,0,0,0-.517-.024,9.006,9.006,0,0,0-2.364.362,2.529,2.529,0,0,0-1.936,2.318c0,1.6,1.554,2.748,3.963,2.748,2.16,0,3.309-1.038,3.309-2.432C385.8,386.741,385.053,386.136,383.341,384.92Zm.653-4.278a2.277,2.277,0,0,0,.562-1.644c0-1.62-.968-4.142-2.835-4.142a2.1,2.1,0,0,0-1.576.743,2.6,2.6,0,0,0-.5,1.666c0,1.508.878,4.007,2.815,4.007A2.3,2.3,0,0,0,383.995,380.642Z",
    transform: "translate(-335.814 -368.203)",
    fill: "#ececec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1140",
    "data-name": "Path 1140",
    d: "M347.557,383.9a5.3,5.3,0,0,1-5.484-5.305,5.569,5.569,0,0,1,5.822-5.461,5.254,5.254,0,0,1,5.371,5.3A5.492,5.492,0,0,1,347.557,383.9Zm2.809-1.82a4.066,4.066,0,0,0,.675-2.5c0-1.978-.944-5.754-3.731-5.754a3.131,3.131,0,0,0-2.022.765,3.4,3.4,0,0,0-1.035,2.743c0,2.224,1.1,5.886,3.822,5.886A2.87,2.87,0,0,0,350.366,382.081Z",
    transform: "translate(-312.604 -367.544)",
    fill: "#ececec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1141",
    "data-name": "Path 1141",
    d: "M310.26,383.9a5.3,5.3,0,0,1-5.484-5.305,5.57,5.57,0,0,1,5.822-5.461,5.254,5.254,0,0,1,5.371,5.3A5.492,5.492,0,0,1,310.26,383.9Zm2.81-1.82a4.072,4.072,0,0,0,.675-2.5c0-1.978-.944-5.754-3.732-5.754a3.132,3.132,0,0,0-2.023.765,3.4,3.4,0,0,0-1.034,2.743c0,2.224,1.1,5.886,3.821,5.886A2.873,2.873,0,0,0,313.07,382.081Z",
    transform: "translate(-287.49 -367.544)",
    fill: "#ececec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1142",
    "data-name": "Path 1142",
    d: "M267.425,373.061l-3.232.746a23.952,23.952,0,0,1-3.728.383c-6.238,0-8.609-4.587-8.609-8.181,0-4.383,3.366-8.45,9.129-8.45a13.007,13.007,0,0,1,3.457.474,8.808,8.808,0,0,1,2.983,1.4l-1.876,1.785-.791.18.565-.9a6.459,6.459,0,0,0-4.835-2.123c-3.571,0-6.26,2.713-6.26,6.667a7.991,7.991,0,0,0,8,8.247,6.728,6.728,0,0,0,2.87-.565v-3.638l-3.411.181,1.807-.973h4.791l-.587.565a.527.527,0,0,0-.227.361c-.024.2-.045.86-.045,1.085Z",
    transform: "translate(-251.856 -357.057)",
    fill: "#ececec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1143",
    "data-name": "Path 1143",
    d: "M414.221,371.373c-.746-.068-.9-.2-.9-1.085V357.5c0-.049.008-.1.012-.146.091-.79.316-.926,1.018-1.333h-3.233l-1.7.814h1.728v13.953c0,.451-.089.519-.61,1.2h4l.836-.5C414.99,371.44,414.605,371.418,414.221,371.373Z",
    transform: "translate(-357.953 -356.019)",
    fill: "#ececec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1144",
    "data-name": "Path 1144",
    d: "M435.381,383.12c-.246.135-.493.293-.739.4a5.227,5.227,0,0,1-2.179.427,4.8,4.8,0,0,1-2.985-.876,5.807,5.807,0,0,1-2.288-4.736,5.086,5.086,0,0,1,5.139-5.183,4.362,4.362,0,0,1,2.313.629,3.714,3.714,0,0,1,1.569,2.22l-5.273,2.133-1.728.135c.56,2.85,2.49,4.509,4.622,4.509A5.8,5.8,0,0,0,436.57,382Zm-2.109-6.688c.425-.157.65-.292.65-.606a2.227,2.227,0,0,0-2.222-1.93c-.9,0-2.58.7-2.58,3.119,0,.382.045.785.068,1.19Z",
    transform: "translate(-369.918 -367.558)",
    fill: "#ececec"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1003",
    "data-name": "Group 1003",
    transform: "translate(66.96 5.598)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1145",
    "data-name": "Path 1145",
    d: "M457.516,373.31v1.481h-.18V373.31h-.49v-.153h1.159v.153Z",
    transform: "translate(-456.846 -373.156)",
    fill: "#ececec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1146",
    "data-name": "Path 1146",
    d: "M462.532,374.79V373.3h-.008l-.456,1.494h-.141l-.46-1.494h-.006v1.494H461.3v-1.634h.28l.417,1.321H462l.41-1.321h.284v1.634Z",
    transform: "translate(-459.844 -373.156)",
    fill: "#ececec"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1024",
    "data-name": "Group 1024",
    transform: "translate(40.323 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1170",
    "data-name": "Path 1170",
    d: "M255.082,964.069a21.089,21.089,0,0,1,2.773-.187,6.189,6.189,0,0,1,4.071,1.114,3.959,3.959,0,0,1,1.432,3.261,4.578,4.578,0,0,1-1.447,3.516,6.709,6.709,0,0,1-4.458,1.3,20.041,20.041,0,0,1-2.371-.108Zm1.312,8.011a9.255,9.255,0,0,0,1.312.054c2.773.012,4.279-1.4,4.279-3.838.015-2.161-1.327-3.489-4.07-3.489a8.256,8.256,0,0,0-1.521.12Z",
    transform: "translate(-255.082 -963.465)",
    fill: "#ececec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1171",
    "data-name": "Path 1171",
    d: "M287.523,978.23a3.26,3.26,0,0,1-3.459-3.341,3.35,3.35,0,0,1,3.578-3.449,3.234,3.234,0,0,1,3.474,3.328,3.362,3.362,0,0,1-3.578,3.462Zm.045-.886a2.311,2.311,0,0,0,2.192-2.536,2.207,2.207,0,1,0-2.207,2.536Z",
    transform: "translate(-274.597 -968.555)",
    fill: "#ececec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1172",
    "data-name": "Path 1172",
    d: "M309.243,971.891l.969,3.288c.193.724.388,1.409.522,2.08h.045c.164-.658.4-1.355.641-2.066l1.178-3.3h1.1l1.118,3.247c.268.765.477,1.463.641,2.121h.045a17.982,17.982,0,0,1,.552-2.107l1.028-3.261h1.3l-2.326,6.495h-1.193l-1.1-3.1a21.319,21.319,0,0,1-.642-2.147h-.029a17.8,17.8,0,0,1-.657,2.161l-1.163,3.086h-1.193l-2.177-6.495Z",
    transform: "translate(-290.647 -968.858)",
    fill: "#ececec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1173",
    "data-name": "Path 1173",
    d: "M343.888,973.346c0-.684-.015-1.221-.06-1.758h1.164l.074,1.06h.03a2.734,2.734,0,0,1,2.385-1.208,2.47,2.47,0,0,1,2.55,2.764v3.878H348.72v-3.744c0-1.047-.433-1.932-1.671-1.932a1.872,1.872,0,0,0-1.759,1.207,1.593,1.593,0,0,0-.09.55v3.918h-1.312Z",
    transform: "translate(-314.839 -968.555)",
    fill: "#ececec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1174",
    "data-name": "Path 1174",
    d: "M369.346,962.607h1.312v9.527h-1.312Z",
    transform: "translate(-332.022 -962.607)",
    fill: "#ececec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1175",
    "data-name": "Path 1175",
    d: "M381.891,978.23a3.26,3.26,0,0,1-3.459-3.341,3.35,3.35,0,0,1,3.578-3.449,3.234,3.234,0,0,1,3.474,3.328,3.363,3.363,0,0,1-3.578,3.462Zm.044-.886a2.311,2.311,0,0,0,2.193-2.536,2.207,2.207,0,1,0-2.207,2.536Z",
    transform: "translate(-338.14 -968.555)",
    fill: "#ececec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1176",
    "data-name": "Path 1176",
    d: "M409.008,976.526a9.788,9.788,0,0,0,.1,1.556h-1.178l-.119-.818h-.044a2.774,2.774,0,0,1-2.207.966,1.967,1.967,0,0,1-2.207-1.865c0-1.57,1.55-2.429,4.338-2.416v-.134c0-.537-.163-1.516-1.64-1.5a3.765,3.765,0,0,0-1.894.483l-.3-.792a5.085,5.085,0,0,1,2.386-.563c2.222,0,2.758,1.355,2.758,2.657Zm-1.282-1.758c-1.431-.027-3.057.2-3.057,1.462a1.1,1.1,0,0,0,1.223,1.128,1.819,1.819,0,0,0,1.774-1.088,1.08,1.08,0,0,0,.06-.375Z",
    transform: "translate(-354.923 -968.555)",
    fill: "#ececec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1177",
    "data-name": "Path 1177",
    d: "M432.25,962.607v7.85c0,.577.016,1.235.06,1.677h-1.178l-.06-1.127h-.03a2.7,2.7,0,0,1-2.445,1.275,3.1,3.1,0,0,1-3.1-3.3,3.238,3.238,0,0,1,3.235-3.489,2.482,2.482,0,0,1,2.178.98h.029v-3.865Zm-1.312,5.676a1.958,1.958,0,0,0-.06-.51,1.9,1.9,0,0,0-1.893-1.355,2.222,2.222,0,0,0-2.162,2.5,2.154,2.154,0,0,0,2.133,2.415,1.953,1.953,0,0,0,1.923-1.409,1.835,1.835,0,0,0,.06-.51Z",
    transform: "translate(-369.831 -962.607)",
    fill: "#ececec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1178",
    "data-name": "Path 1178",
    d: "M464.379,978.23a3.26,3.26,0,0,1-3.459-3.341,3.351,3.351,0,0,1,3.578-3.449,3.234,3.234,0,0,1,3.475,3.328,3.363,3.363,0,0,1-3.578,3.462Zm.045-.886a2.311,2.311,0,0,0,2.191-2.536,2.206,2.206,0,1,0-2.206,2.536Z",
    transform: "translate(-393.684 -968.555)",
    fill: "#ececec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1179",
    "data-name": "Path 1179",
    d: "M487.458,973.346c0-.684-.015-1.221-.06-1.758h1.163l.075,1.06h.029a2.734,2.734,0,0,1,2.385-1.208,2.47,2.47,0,0,1,2.55,2.764v3.878h-1.312v-3.744c0-1.047-.432-1.932-1.67-1.932a1.874,1.874,0,0,0-1.76,1.207,1.6,1.6,0,0,0-.089.55v3.918h-1.312Z",
    transform: "translate(-411.513 -968.555)",
    fill: "#ececec"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayStore);
export default __webpack_public_path__ + "static/media/playStore.e68be4b0ee3d1c03962f355c58687628.svg";
export { ForwardRef as ReactComponent };